import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppCard, AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import { Accordion } from 'react-bootstrap';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import * as currentPageAction from '../../../store/actions/currentPageAction';
import Translator from '../../../layout/components/helpers/Translator';
import Sidebar from '../../../layout/Sidebar/Sidebar';
import AppLink from '../../../routing/helpers/AppLink';
import { axiosPath } from '../../../routing/helpers/router';
import colors from '../../../constants/colors';
import useIsMounted from '../../../layout/components/hooks/useIsMounted';

const LegalCompliancePendingEmailsScreen = () => {
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);
  const [userPendingEmails, setUserPendingEmails] = useState();

  useEffect(
    () => () => {
      dispatch(currentPageAction.empty());
    },
    []
  );

  const loadUserPendingEmails = async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_emailQueue_getUserList"),
        { moduleBridgeHex }
      );
      return response.data;
    } catch (err) {}
  };

  useEffect(() => {
    loadUserPendingEmails().then((r) => {
      if (isMounted.current) setUserPendingEmails(r.mails);
    });
  }, []);
  // < LOAD CALENDAR INFO
  if (userPendingEmails === undefined) return <AppNoInfo />;

  return (
    <>
      <BreadcrumbHandler
        paths={[
          {
            name: ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="pending.emails" />
            ),
          },
        ]}
      />
      <Sidebar>
        <img
          src={auth.user?.client?.logoUrl}
          className="img-fluid"
          alt={auth.user?.client?.name}
          title={auth.user?.client?.name}
        />
        <Accordion>
          <ul>
            <li>
              <AppLink
                path="user_module_legalCompliance_home"
                params={{
                  moduleBridgeHex,
                  page: 0,
                  filterHex: 0,
                }}
                className="sidebar-element"
              >
                <AppRemixIcon
                  icon="arrow-go-back-line"
                  className="sidebar-icon"
                  noVariants
                />{' '}
                <span className="sb-title">
                  <Translator
                    file="user"
                    name="user.password.forgotten.remember.back"
                  />
                </span>
              </AppLink>
            </li>
            <li className="divider" />
          </ul>
        </Accordion>
      </Sidebar>

      <div className="p-2">
        <AppCard
          header={ReactDOMServer.renderToString(
            <Translator
              file="module-legalCompliance"
              name="pending.send.obligations.list"
            />
          )}
        >
          {userPendingEmails.length === 0 ? (
            <AppNoInfo
              text={ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="no.pending.sends"
                />
              )}
              icon={
                <AppRemixIcon
                  icon="mail-send"
                  size={24}
                  color={colors.primaryLight}
                />
              }
            />
          ) : (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col-lg-6">
                    <Translator file="module-intelligence" name="plant" />
                  </th>
                  <th scope="col-lg-6">
                    <Translator
                      file="module-legalCompliance"
                      name="obligation.code"
                    />
                  </th>
                  <th scope="col-lg-6">
                    <Translator
                      file="module-legalCompliance"
                      name="send.date"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {userPendingEmails.map((e) => (
                  <tr key={e.id}>
                    <td>{e.plant}</td>
                    <td>{e.obligationHex}</td>
                    <td>{e.mailingDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </AppCard>
      </div>
    </>
  );
};

export default LegalCompliancePendingEmailsScreen;
